export const onChangeHandler = (setFieldValue, onChange, setValues) => (
	e,
	args
) => {
	onChange(e, args, { setFieldValue, setValues });
};

export const defaultChangeHandler = setFieldValue => (
	e,
	{ name, value } = {}
) => {
	const {
		target: { name: fieldName, value: fieldValue },
	} = e;
	const newFieldName = name || fieldName;
	const newFieldValue = value || fieldValue;

	setFieldValue(newFieldName, newFieldValue);
};
